module.exports = __webpack_public_path__ + "static/media/kendrafoundit-IG-4.c5fcf3da.PNG";